export interface Filters {
    keyword: string;
    status: string[];
    right?: string;
    main_request: boolean;
    allocationTypeOrBudget?: string | null;
    type?: string | null;
    distinct_request?: boolean;
    ownerUuid: {
        uuid: string | null;
    };
    scopeOwnerUuid?: string | null;
    hierarchyOwner?: string | null;
    topic?: string | null;
    usersRequester?: string[];
    usersAssigned?: string[];
}

interface State {
    filters: RequestFilters;
}

export type RequestFilters = Filters | null;

const STORAGE_KEY = "requestFilters";

export default {
    state: {
        filters: null,
    } as State,

    mutations: {
        updateRequestFilters(state: State, filters: RequestFilters): void {
            if (!filters) {
                localStorage.removeItem(STORAGE_KEY);
                state.filters = null;
                return;
            }
            state.filters = Object.assign({}, state.filters, filters);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state.filters));
        },
        setRequestFilters(state: State, filters: RequestFilters): void {
            if (!filters) {
                localStorage.removeItem(STORAGE_KEY);
                state.filters = null;
                return;
            }
            state.filters = Object.assign({}, filters);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state.filters));
        },
    },
    getters: {
        getRequestFilters: (state: State): RequestFilters => state.filters,
    },
    actions: {
        initializeRequestFilters(
            { commit }: { commit: (mutation: string, payload: RequestFilters) => void },
            filters: RequestFilters = null
        ): void {
            try {
                const stored = localStorage.getItem(STORAGE_KEY);
                commit("setRequestFilters", stored ? JSON.parse(stored) : filters || {});
            } catch {
                localStorage.removeItem(STORAGE_KEY);
                commit("setRequestFilters", filters || null);
            }
        },
        resetRequestFilters(
            {commit}: { commit: (mutation: string, payload: RequestFilters) => void },
            filters: RequestFilters
        ): void {
            commit("setRequestFilters", filters);
        },
        updateRequestFilters(
            {commit}: { commit: (mutation: string, payload: RequestFilters) => void },
            filters: RequestFilters
        ): void {
            commit("updateRequestFilters", filters);
        },
    },
};
